// extracted by mini-css-extract-plugin
export default {"main":"projects_main__07jXb","container":"projects_container__nNNkE"};